import React, { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import { IoMdCloudUpload } from 'react-icons/io';
import { MAX_UPLOADS, Plan } from '../../firebase/firestore';
import { useAuth } from '../../hooks/useAuth';
import { sum } from '../../utils/arrays';



export function TrackUploadArea({ uploadFiles, ...rest }): JSX.Element {
  const [canUpload, setCanUpload] = useState(true);
  const { user } = useAuth();

  function canUploadMore(plan: Plan, occupiedMb: number): boolean {
    // todo: when 500mb limit, 499mb uploaded, it'll allow to upload 10mb in UI but not in actuality.
    if (occupiedMb === null || occupiedMb === undefined)
      throw new Error("occupied not supplied");
    return occupiedMb < MAX_UPLOADS[plan];
  }


  const { getRootProps, getInputProps, isDragActive, isDragAccept, acceptedFiles, fileRejections } = useDropzone({
    accept: ['.wav', '.mp3', 'audio/x-wav', 'audio/mpeg'], onDrop: files => {
      if (!canUploadMore(user?.plan || "free", user.occupied + sum(files.map(f => f.size / 1024 / 1024)))) {
        setCanUpload(false);
      } else {
        setCanUpload(true);
        uploadFiles(files);
      }
    }
  });

  return canUpload ? <div>
    <div style={{ color: "#B5B5B5" }} className={`p-5 mb-4 text-sm  text-center rounded-md border-dashed ${isDragAccept ? "bg-bgactive_" : "bg-bgactive"} transition hover:bg-bgactive_`} {...getRootProps()}>
      <input {...getInputProps()} />
      {isDragAccept ?
        <p>Drop your tracks here</p> :
        <div className='flex items-center justify-center'><IoMdCloudUpload size={18} className='mr-1 '/> Upload new tracks (drag & drop or&nbsp;<u>select files</u>)</div>}
      <div className='opacity-70'>
        <div className={`mt-2 text-xxs leading-4`}>Add bpm to the filename to make sure it's recognized (e.g. <i>My Beat <b>127bpm Am</b>.wav</i>).</div>
        <div className={` text-xxs leading-3`}>Stems are grouped together if they start with the same name (e.g. <i><b>beat1</b> Guitar.wav, <b>beat1</b> Piano.wav</i>).</div>
      </div>
    </div>
  </div> :
    <div style={{ color: "#B5B5B5" }} className={`p-5 mb-4 text-sm  text-center rounded-md border-dashed bg-bgactive cursor-not-allowed`}>
      Your storage is full. Upgrade your plan or delete some tracks.
    </div>;
}
